import { useEffect } from "react";
import { useLocation } from "react-router-dom";


const ScrollToTop = () => {

    const location = useLocation();

    useEffect(() => {
        if ('scrollRestoration' in window.history) {
            const prev = window.history.scrollRestoration;
            window.history.scrollRestoration = 'manual';
            return () => { window.history.scrollRestoration = prev; };
        }
    }, []);

    useEffect(() => {
        const path = location.pathname;
        const scrollToTopNow = () => {
            try {
                const active = document.activeElement;
                if (active && typeof active.blur === 'function') active.blur();

                window.scrollTo(0, 0);
                if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;
            } catch (e) {
            }
        };
        requestAnimationFrame(() => {
            scrollToTopNow();
            setTimeout(() => {
                scrollToTopNow();
                requestAnimationFrame(scrollToTopNow);
            }, 50);
        });
    }, [location.pathname]);

    return null;
};

export default ScrollToTop;
